import styled from "@emotion/styled";
import FlexCenter from "shared/components/Layout/components/FlexCenter";

export const StyledUploadImageWrapper = styled(FlexCenter)`
  border-radius: 0.5rem;
  padding: 0 1rem;
  height: 40px;
  column-gap: 0.5rem;

  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23DDDDDDFF' stroke-width='2' stroke-dasharray='4%2c 6' stroke-dashoffset='15' stroke-linecap='round'/%3e%3c/svg%3e");
`;

export const StyledUploadInput = styled(FlexCenter)`
  position: relative;
  column-gap: 0.5rem;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  cursor: pointer;
`;

export const StyledUploadImage = styled(FlexCenter)`
  width: 24px;
  height: 24px;
  border-radius: 4px;

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 4px;
  }
`;
